import {
    AnyAction,
    createSlice,
    PayloadAction,
    Reducer,
} from '@reduxjs/toolkit';

import {
    CommbankLiabilitiesState,
    FetchCommbankLiabilitiesPayload,
    UpdateCommbankLiabilitiesEndpoints,
    UpdateCommbankLiabilityPayload,
} from './commbankLiabilitiesTypes';
import { initialStateCommbankLiabilities as initialState } from './commbankLiabilitiesDefaultValue';
import { ApiStatus } from '../../types';

const commbankLiabilitiesSlice = createSlice({
    name: 'commbankLiabilities',
    initialState,
    reducers: {
        getCommbankLiabilities(state) {
            state.getCommbankLiabilitiesAPIStatus = ApiStatus.Pending;
        },
        getCommbankLiabilitiesFulfilled(state, action: PayloadAction<FetchCommbankLiabilitiesPayload>) {
            const{ content, commbankLiabilities } = action.payload;

            state.getCommbankLiabilitiesAPIStatus = ApiStatus.Fulfilled;
            state.content = JSON.parse(content);
            state.commbankLiabilitiesDetails = commbankLiabilities;
            state.updateCommbankLiabilitiesPayload = [];

        },
        getCommbankLiabilitiesRejected(state) {
            state.getCommbankLiabilitiesAPIStatus = ApiStatus.Rejected;
        },
        getCommbankLiabilitiesInvalid(state) {
            state.getCommbankLiabilitiesAPIStatus = ApiStatus.Idle;
        },
        commbankLiabilitiesSubmit(state) {
            state.updateCommbankLiabilitiesAPIStatus = ApiStatus.Pending;
        },
        updateCommbankLiabilitiesFulfilled(state) {
            state.updateCommbankLiabilitiesAPIStatus = ApiStatus.Fulfilled;
            // Update back data from request payload before cleaning
            state.commbankLiabilitiesDetails = state.commbankLiabilitiesDetails.map((item) => {
                const newRepaymentShare = (
                    state.updateCommbankLiabilitiesPayload.find(reqPayloadItem => (
                        reqPayloadItem.liabilityId === item.liabilityId
                    ))?.repaymentShare
                );

                if(newRepaymentShare) {
                    return {
                        ...item,
                        repaymentShare: newRepaymentShare,
                    };
                }

                return item;
            });
            state.updateCommbankLiabilitiesPayload = [];
        },
        updateCommbankLiabilitiesRejected(state) {
            state.updateCommbankLiabilitiesAPIStatus = ApiStatus.Rejected;
        },
        updateCommbankLiabilitiesPayload: (state, action: PayloadAction<UpdateCommbankLiabilityPayload>) =>{
            const matchedIndex = state.updateCommbankLiabilitiesPayload.findIndex((d) => d.liabilityId === action.payload.liabilityId);

            const defaultRepaymentShare = (
                state.commbankLiabilitiesDetails.find((item) => (
                    item.liabilityId === action.payload.liabilityId
                ))?.repaymentShare) || '';

            if(matchedIndex > -1) {
                if(defaultRepaymentShare === action.payload.repaymentShare) {
                    // Remove liability payload when user changed back to default repaymentShare
                    state.updateCommbankLiabilitiesPayload.splice(matchedIndex, 1);
                } else {
                    state.updateCommbankLiabilitiesPayload[matchedIndex].repaymentShare = action.payload.repaymentShare;
                }
            } else if(defaultRepaymentShare !== action.payload.repaymentShare) {
                // Only add new liability payload
                // When liability payload doesn't exist
                // And new repaymentShare not equal to default repaymentShare
                state.updateCommbankLiabilitiesPayload.push(action.payload);
            }

        },
        updateCommbankLiabilitiesEndpoints: (state, action: PayloadAction<UpdateCommbankLiabilitiesEndpoints>) => {
            state.apiEndpoints = {
                ...state.apiEndpoints,
                ...action.payload,
            };

        },
        resetCommbankLiabilitiesStatus: (state) => {
            state.getCommbankLiabilitiesAPIStatus = ApiStatus.Idle;
            state.updateCommbankLiabilitiesAPIStatus = ApiStatus.Idle;
        },
    },
});

export const {
    getCommbankLiabilities,
    getCommbankLiabilitiesFulfilled,
    getCommbankLiabilitiesRejected,
    getCommbankLiabilitiesInvalid,
    commbankLiabilitiesSubmit,
    updateCommbankLiabilitiesFulfilled,
    updateCommbankLiabilitiesRejected,
    updateCommbankLiabilitiesPayload,
    updateCommbankLiabilitiesEndpoints,
    resetCommbankLiabilitiesStatus,
} = commbankLiabilitiesSlice.actions;

export const commbankLiabilitiesReducer: Reducer<CommbankLiabilitiesState, AnyAction> = commbankLiabilitiesSlice.reducer;
